import React from 'react';
import './css/logoMono.css'

function LogoMono() {
    return (
      <div className="LogoMono">
        <footer className="LogoMono-header">
        </footer>
      </div>
    );
  }
  
  export default LogoMono;
